import { render } from "./AddDnsServer.vue?vue&type=template&id=200f9712&scoped=true"
import script from "./AddDnsServer.vue?vue&type=script&lang=js"
export * from "./AddDnsServer.vue?vue&type=script&lang=js"

import "./AddDnsServer.vue?vue&type=style&index=0&id=200f9712&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200f9712"]])

export default __exports__